/** Vite-exposed env (also accepts REACT_APP_* via vite.config envPrefix). */
export function getApiBaseUrl(fallback = "http://localhost:8000") {
  return (
    import.meta.env.VITE_API_URL ||
    import.meta.env.REACT_APP_API_URL ||
    fallback
  );
}

export function getApiSecret() {
  return (
    import.meta.env.VITE_API_SECRET ||
    import.meta.env.REACT_APP_API_SECRET ||
    ""
  );
}
